import { render } from "./PageDevelopmentTools.vue?vue&type=template&id=5893b24d"
import script from "./PageDevelopmentTools.vue?vue&type=script&lang=js"
export * from "./PageDevelopmentTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__